import { User, Bell, Lock, HelpCircle, LogOut, ChevronRight, Book, Award, Calendar, Users } from 'lucide-react';
import { Link } from 'react-router-dom';


export default function ExpertSettingsPage() {
  return (
    <div className="settings-container-apss">
      <h1 className="settings-title-apss">Expert Settings</h1>
     
      <div className="settings-cards-apss">
        {/* Account Settings Card */}
        <Link to="/expert-dashboard/settings/account" className="settings-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss account-icon-apss">
              <User size={24} color='#fff' />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Account Settings</h3>
              <p className="settings-card-description-apss">Update your profile information</p>
            </div>
          </div>
          <ChevronRight className="settings-chevron-apss" size={20} />
        </Link>


       
        {/* Notifications Card */}
      {/*   <Link to="/expert-dashboard/settings/notifications" className="settings-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss notification-icon-apss">
              <Bell size={24} color='#fff' />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Notifications</h3>
              <p className="settings-card-description-apss">Configure your consultation and system notifications</p>
            </div>
          </div>
          <ChevronRight className="settings-chevron-apss" size={20} />
        </Link> */}
       
        {/* Privacy & Security Card */}
        <Link to="/expert-dashboard/settings/privacy&security" className="settings-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss security-icon-apss">
              <Lock size={24} color='#fff' />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Privacy & Security</h3>
              <p className="settings-card-description-apss">Manage your password and security settings</p>
            </div>
          </div>
          <ChevronRight className="settings-chevron-apss" size={20} />
        </Link>
       
        {/* Help & Support Card */}
        <Link to="/expert-dashboard/settings/help" className="settings-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss help-icon-apss">
              <HelpCircle size={24} color='#fff' />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Help & Support</h3>
              <p className="settings-card-description-apss">Get help with your Agrictech  expert account</p>
            </div>
          </div>
          <ChevronRight className="settings-chevron-apss" size={20} />
        </Link>
       
        
        <div className="settings-card-apss logout-card-apss">
          <div className="settings-card-content-apss">
            <div className="settings-icon-container-apss logout-icon-apss">
              <LogOut size={24} color="#fff" />
            </div>
            <div className="settings-info-apss">
              <h3 className="settings-card-title-apss">Logout</h3>
              <p className="settings-card-description-apss">Sign out of your account</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}